import { allRafflesAPI } from "@src/api/raffle-draw";
import { raffleRNGAPI } from "@src/api/rewards-management";
import { usePartnerDropdownContext } from "@src/context/PartnerDropdown";
import { useToasterContext } from "@src/context/Toaster";
import { CreateContextStateType, UseRNGServiceOperators } from "@src/lib/types/rng";
import { AlertType } from "@src/lib/types/toaster";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useRNG } from "./provider";

export const useService = (): Readonly<UseRNGServiceOperators> => {
    const { state } = useRNG();
    const { triggerOpen } = useToasterContext();
    const { state: { selectedPartnerId } } = usePartnerDropdownContext();
    const { debouncedCode } = state || {};

    const { data: raffleList } = useQuery({
      queryKey: ["raffle-list-all", { selectedPartnerId }],
      queryFn: () => allRafflesAPI({ partnerId: selectedPartnerId }),
      staleTime: 5 * 60 * 1000,
      select: (res) => res?.items ?? [],
    });

    const runDraw = useMutation({
      mutationKey: ['raffles-rng', { selectedPartnerId, debouncedCode }],
      mutationFn: async (args?: Partial<CreateContextStateType>) => {
        const result = await raffleRNGAPI({
          ...args,
          partnerId: selectedPartnerId
        });

        return result;
      },
      onError: (error: any) => {
        triggerOpen({
          type: AlertType.error,
          title: "RNG",
          message: typeof error === "string" ? error : error?.message || "Failed to fetch",
        });
      },
    });


    return {
      entriesResult: {},
      entriesLoading: false,
      raffleList: raffleList ?? [],
      runDraw,
    };
  };
